import { ProjectType } from '@buildwise/pages/projects/hooks/useProjectsQuery';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { theme } from 'config/theme';
import { PROJECT } from 'constants/routes';
import { memo } from 'react';
import { Link as RouterLink, useLocation, useSearchParams } from 'react-router-dom';
import BuildingLineIcon from 'remixicon-react/BuildingLineIcon';
import { highlightSearchKeyword } from 'utility/helpers';

type PostProjectProps = {
  project: ProjectType;
  searchKeyword: string;
};

function PostProject({ project, searchKeyword }: PostProjectProps) {
  const { state } = useLocation();
  const [searchParams] = useSearchParams();

  return (
    <Link
      to={`${PROJECT?.replace(':projectId', project.id)}${
        searchParams.get('q') ? `?q=${searchParams.get('q')}` : ''
      }`}
      state={searchKeyword && { ...state }}
    >
      <ProjectContainer>
        <BuildingLineIcon color={theme.palette.custom.body} />
        <ProjectName
          dangerouslySetInnerHTML={{
            __html: highlightSearchKeyword(project?.name, searchKeyword),
          }}
        />
      </ProjectContainer>
    </Link>
  );
}

const ProjectContainer = styled(Box, { label: 'ProjectContainer' })({
  width: '100%',
  paddingTop: 8,
  display: 'flex',
  alignItems: 'center',
  gap: 8,
});

const Link = styled(RouterLink, { label: 'Link' })(({ theme }) => ({
  display: 'inline-block',
  height: 'fit-content',
  width: 'fit-content',
  '&:hover': {
    textDecoration: 'underline',
    color: theme.palette.custom.link,
  },
}));

const ProjectName = styled(Typography, { label: 'ProjectName' })(({ theme }) => ({
  fontSize: 16,
  cursor: 'pointer',
  width: 'fit-content',
  display: 'block',
  '& .highlight': {
    backgroundColor: 'yellow !important',
  },
  '&:hover': {
    textDecoration: 'underline',
    color: theme.palette.custom.link,
  },
}));

export default memo(PostProject);
